var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.63281 18.9999V8.87941H4.20251V18.9999H7.63281ZM5.9181 7.4968C7.11431 7.4968 7.85889 6.71966 7.85889 5.7485C7.8366 4.75544 7.11436 3.99988 5.9408 3.99988C4.76743 3.99988 4.00012 4.75546 4.00012 5.7485C4.00012 6.71971 4.74452 7.4968 5.89571 7.4968H5.918H5.9181ZM9.53147 18.9999H12.9618V13.3481C12.9618 13.0456 12.9841 12.7435 13.0746 12.5273C13.3226 11.9229 13.8871 11.297 14.8346 11.297C16.0759 11.297 16.5725 12.2251 16.5725 13.5856V18.9998H20.0026V13.1968C20.0026 10.0882 18.3103 8.64181 16.0533 8.64181C14.2028 8.64181 13.3903 9.65614 12.939 10.347H12.9619V8.8792H9.53155C9.57657 9.82885 9.53155 18.9997 9.53155 18.9997L9.53147 18.9999Z",
    fill: "#F6F6F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15,
    fill: "white",
    transform: "translate(4.00012 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.a80e842bc04147243ec558934419b510.svg";
export { ForwardRef as ReactComponent };